import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {
    areAllCustomersAssigned,
    areAllProjectsAssigned,
    areAllTasksAssigned,
    areFutureCustomersAssigned,
    areFutureProjectsAssigned,
    areFutureTasksAssigned,
    areSomeCustomersOrLowerAssigned,
    areSomeProjectsOrLowerAssigned,
    areSomeTasksAssigned,
    canManageParentCustomer,
    canManageParentProject,
    getCanManageCustomerExcludeSelfIds,
    getCanManageCustomerIds,
    getCanManageProjectExcludeSelfIds,
    getCanManageProjectIds,
    getCanManageTaskIds,
    getCanWorkCustomerIds,
    getCanWorkProjectIds,
    getCanWorkTaskIds,
    getChangingCustomerAssignments,
    getChangingProjectAssignments,
    getChangingTaskAssignments,
    getCustomers, getCustomersSearchOpen, getCustomersSearchText,
    getEditingUser,
    getProjectCountsByCustomers,
    getProjects, getProjectsSearchOpen, getProjectsSearchText,
    getSelectedCustomer,
    getSelectedProject,
    getTaskCountsByCustomers,
    getTaskCountsByProjects,
    getTasks, getTasksSearchOpen, getTasksSearchText,
    getViewerCanManageCustomerIds,
    getViewerCanManageProjectIds,
    isChangingAllAssignments,
    isLoading,
} from '../selectors'
import {
    changeAllCustomersAssignments,
    changeAllProjectsAssignments,
    changeAllTasksAssignments,
    changeCustomerAssignment, changeCustomersSearchText,
    changeProjectAssignment, changeProjectsSearchText,
    changeTaskAssignment, changeTasksSearchText, clearCustomersSearchText, clearProjectsSearchText,
    clearTasksSearchText,
    closeEditor,
    deselectCustomer,
    deselectProject,
    loadMoreEntities,
    selectCustomer,
    selectProject,
} from '../actions'
import HierarchyAssignmentsEditor from "../../components/hierarchyAssignmentsEditor/HierarchyAssignmentsEditor"
import messageResource from '../../../../messageResource'
import {HierarchyLevels} from 'constants'
import {hasAccessAllManagementScope} from '../../../../loggedInUser/selectors'

export class WorkAssignmentsEditor extends HierarchyAssignmentsEditor {
    constructor(params) {
        super({
            headerMessageKey: 'userlist.wa_editor.title',
            workAssignmentsVisible: true,
            managementAssignmentsEditable: false,
            showAllExistingFuturesSwitcher : false,
            getAssignAllTextsMap: () => this._getAssignAllTextsMap(),
            getRevokeAllTextsMap: () => this._getRevokeAllTextsMap(),
            getAssignTextsMap: () => this._getAssignTextsMap(),
            getRevokeTextsMap: () => this._getRevokeTextsMap(),
            ...params
        })
    }

    _getAssignAllTextsMap() {
        return {
            [HierarchyLevels.CUSTOMER]: messageResource.getMessage('userlist.wa_editor.customers.assign_all'),
            [HierarchyLevels.PROJECT]: messageResource.getMessage('userlist.wa_editor.projects.assign_all'),
            [HierarchyLevels.TASK]: messageResource.getMessage('userlist.wa_editor.tasks.assign_all'),
        }
    }

    _getRevokeAllTextsMap() {
        return {
            [HierarchyLevels.CUSTOMER]: messageResource.getMessage('userlist.wa_editor.customers.unassign_all'),
            [HierarchyLevels.PROJECT]: messageResource.getMessage('userlist.wa_editor.projects.unassign_all'),
            [HierarchyLevels.TASK]: messageResource.getMessage('userlist.wa_editor.tasks.unassign_all'),
        }
    }

    _getAssignTextsMap() {
        return {
            [HierarchyLevels.CUSTOMER]: messageResource.getMessage('userlist.wa_editor.revoke_menu.customer.grant'),
            [HierarchyLevels.PROJECT]: messageResource.getMessage('userlist.wa_editor.revoke_menu.project.grant'),
            [HierarchyLevels.TASK]: messageResource.getMessage('userlist.wa_editor.revoke_menu.task.grant'),
        }
    }

    _getRevokeTextsMap() {
        return {
            [HierarchyLevels.CUSTOMER]: messageResource.getMessage('userlist.wa_editor.revoke_menu.customer.revoke'),
            [HierarchyLevels.PROJECT]: messageResource.getMessage('userlist.wa_editor.revoke_menu.project.revoke'),
            [HierarchyLevels.TASK]: messageResource.getMessage('userlist.wa_editor.revoke_menu.task.revoke'),
        }
    }
}

export default connect(
    state => ({
        viewerCanManageCustomerIds: getViewerCanManageCustomerIds(state),
        viewerCanManageProjectIds: getViewerCanManageProjectIds(state),
        user: getEditingUser(state),
        customers: getCustomers(state),
        projects: getProjects(state),
        tasks: getTasks(state),
        futureCustomersAssigned: areFutureCustomersAssigned(state),
        futureProjectsAssigned: areFutureProjectsAssigned(state),
        futureTasksAssigned: areFutureTasksAssigned(state),
        someCustomersOrLowerAssigned: areSomeCustomersOrLowerAssigned(state),
        someProjectsOrLowerAssigned: areSomeProjectsOrLowerAssigned(state),
        someTasksAssigned: areSomeTasksAssigned(state),
        allCustomersAssigned: areAllCustomersAssigned(state),
        allProjectsAssigned: areAllProjectsAssigned(state),
        allTasksAssigned: areAllTasksAssigned(state),
        canWorkCustomerIds: getCanWorkCustomerIds(state),
        canManageCustomerIds: getCanManageCustomerIds(state),
        canManageCustomerExcludeSelfIds: getCanManageCustomerExcludeSelfIds(state),
        canWorkProjectIds: getCanWorkProjectIds(state),
        canManageProjectIds: getCanManageProjectIds(state),
        canManageProjectExcludeSelfIds: getCanManageProjectExcludeSelfIds(state),
        canWorkTaskIds: getCanWorkTaskIds(state),
        canManageTaskIds: getCanManageTaskIds(state),
        projectCountsByCustomers: getProjectCountsByCustomers(state),
        taskCountsByCustomers: getTaskCountsByCustomers(state),
        taskCountsByProjects: getTaskCountsByProjects(state),
        selectedCustomer: getSelectedCustomer(state),
        selectedProject: getSelectedProject(state),
        loading: isLoading(state),
        changingCustomerAssignments: getChangingCustomerAssignments(state),
        changingProjectAssignments: getChangingProjectAssignments(state),
        changingTaskAssignments: getChangingTaskAssignments(state),
        customersSearchOpen: getCustomersSearchOpen(state),
        customersSearchText: getCustomersSearchText(state),
        projectsSearchOpen: getProjectsSearchOpen(state),
        projectsSearchText: getProjectsSearchText(state),
        tasksSearchOpen: getTasksSearchOpen(state),
        tasksSearchText: getTasksSearchText(state),
        changingAllAssignments: isChangingAllAssignments(state),
        canManageParentCustomer: canManageParentCustomer(state),
        canManageParentProject: canManageParentProject(state),
        viewerHasAccessAllManagementScope: hasAccessAllManagementScope(state)
    }),
    dispatch => bindActionCreators({
        changeCustomerAssignment,
        changeProjectAssignment,
        changeTaskAssignment,
        changeAllCustomersAssignments,
        changeAllProjectsAssignments,
        changeAllTasksAssignments,
        deselectCustomer,
        deselectProject,
        selectCustomer,
        selectProject,
        loadMoreEntities,
        changeCustomersSearchText,
        clearCustomersSearchText,
        changeProjectsSearchText,
        clearProjectsSearchText,
        changeTasksSearchText,
        clearTasksSearchText,
        closeEditor,
    }, dispatch)
)(WorkAssignmentsEditor)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsEditor/components/WorkAssignmentsEditor.js